import Consts from "Interfaces/Consts";
import { Filter } from 'Interfaces/general.interface';

type Props = {
    componentId: string;
    totalSearchResults: number;
    filters: (Filter | null)[];
    filterValues: string[];
    resetFilter: (filterItemIndex: number) => void;
    resetAllFilters: () => void;
    isDisplayedWhenNoActiveFiltersExist: boolean;
}

const FiltersFooter: React.FC<Props> = ({
    filters,
    componentId,
    totalSearchResults,
    resetFilter,
    resetAllFilters,
    filterValues,
    isDisplayedWhenNoActiveFiltersExist
}) => {

    const checkIfActiveFiltersExists = () => filterValues.some((filterValue) => filterValue !== "");

    const hasActiveFilters = checkIfActiveFiltersExists();

    return (

        <div id={`result-line-${componentId}`} className="filters-actions-wrapper my-3" >

            {
                (hasActiveFilters || isDisplayedWhenNoActiveFiltersExist) &&

                    <>
                    {
                        totalSearchResults > 0 &&
                        <div className="mx-1 results-found-text">{Consts.resaultsFound.replace('{number}', totalSearchResults.toString())}</div>
                    }

                    {

                        checkIfActiveFiltersExists() &&

                        <div className="d-flex flex-wrap">

                            {
                                filters.map((item, idx) => {

                                    return filterValues[idx] &&

                                        <div key={idx} id={`${componentId}_filter_select_${idx}`} className="mst-filter-name">
                                            <button
                                                aria-label={Consts.removeFromFilters.replace('{filterValue}', `"${filterValues[idx]}"` ) }
                                                className="mst-reset-selection-btn" onClick={() => { resetFilter(idx) }}>

                                                <i style={{color: '#333333'}} aria-hidden="true" className="fa fa-times"></i>

                                            </button>
                                            <span className="mst-filter-selection">{filterValues[idx]}</span>
                                        </div>

                                }

                            )}


                            <button className="reset-all-filters-btn txt-pallete-color" onClick={resetAllFilters}>
                                {Consts.resetFilters}
                            </button>

                        </div>
                    }

                    </>

            }

        </div>

    );

}

export default FiltersFooter;